import QuickLinksLogoContainer from './QuickLinksLogoContainer'

export default QuickLinksLogoContainer;